import { useContext, useRef, useState } from "react";
import t from "../locales";
import clsx from "clsx";
import { fetchData } from "../helpers/fetch-data";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { ClassContext } from "../app";

export const ClassForm = () => {
  const inputRef = useRef("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { setProfiles } = useContext(ClassContext);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setError(null);

    if (!inputRef.current.value) {
      setError(t("dashboard.form.errors.no_input"));
      return;
    }

    try {
      const query = await fetchData(inputRef.current.value);

      setProfiles(query);
      navigate(`/dashboard/${inputRef.current.value}`);
    } catch (error) {
      if (import.meta.env.DEV) {
        // We only log this in development
        // eslint-disable-next-line no-console
        console.error(error);
      }
      Sentry.captureException(error);
      setError(t("dashboard.form.errors.unexpected"));
    }
  };

  return (
    <>
      <title>{t("header.title")}</title>
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <h1 className="form__title" id="classLabel">
            {t("dashboard.form.title")}
          </h1>
          <p className="form__description" id="classDescription">
            {t("dashboard.form.description")}
          </p>
        </div>
        <input
          className={clsx("form__input", error && "form__input--invalid")}
          type="text"
          name="class"
          ref={inputRef}
          id="class"
          placeholder={t("dashboard.form.placeholder")}
          aria-labelledby="classLabel"
          aria-describedby="classDescription"
        />
        {error ? <p className="form__error-message">{error}</p> : null}
        <button className="button" type="submit">
          {t("dashboard.form.submit")}
        </button>
      </form>
    </>
  );
};
